// --- Our Modules --------------------------------------------------------------------------------
import useLang from "@/hooks/useLang";
import useTranslation from "@/hooks/useTranslation";
import { formatBytes } from "@/utils";
import Icon from "@/UI/atoms/Icon";
import type { TyIconName } from "@/UI/atoms/Icon/types";
import "./styles.css";
// --- Logic --------------------------------------------------------------------------------------
type Props = { label: string; count: number; size: number; icon?: TyIconName; onOpen: () => void };

/**
 * One node of the drive tree — a folder or a record inside it. The tree is derived from what the files
 * say about themselves, so this card is never a stored folder and has nothing to rename or delete.
 */
export default function FolderCard({ label, count, size, icon = "folder", onOpen }: Props) {
    const t = useTranslation();
    const lang = useLang((state) => state.lang) ?? "ar";

    return (
        <button type="button" className={`folder-card${count ? "" : " folder-card--empty"}`} onClick={onOpen}>
            <Icon name={icon} size={26} />

            <span className="folder-card__identity">
                <span className="folder-card__label">{label}</span>
                <span className="folder-card__meta">
                    {count} {t.drive.files} · {formatBytes(size, lang)}
                </span>
            </span>

            <span className="folder-card__arrow">
                <Icon name="chevron" size={16} />
            </span>
        </button>
    );
}
